<template>
  <div class="container">
    <!-- swipe区 -->
    <div class="swipe">
      <div class="swipe_box">
        <el-carousel trigger="click" width="100%" :height="swipeHeight + 'px'">
          <el-carousel-item v-for="(item, index) in banners" :key="index" @click.native="toWebLink(item.url)">
            <img :src="item.pic" alt="" />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>

    <!-- 筛选条件 -->
    <div class="screen">
      <div class="w">
        <div class="screen_box">
          <div class="left-box">
            <div class="title">
              <span>我要买车</span>
              <div class="search">
                <el-input class="el-input-index" placeholder="请输入感兴趣的品牌、车系" v-model="keyword" clearable>
                  <i class="el-icon-search el-input__icon" slot="suffix" @click="toBuyCar('keyword')"> </i>
                </el-input>
              </div>
            </div>
            <div class="screen_box">
              <div v-for="(item, index) in hotBrands" :key="index" @click="toBuyCar('brand', item.id)">
                <img :src="item.logoImg" alt="" />
                <span>{{ item.name }}</span>
              </div>
            </div>
            <div class="screen_box">
              <div v-for="(item, index) in carPrices" :key="index" @click="toBuyCar('price', item.value)">
                <span>{{ item.text }}</span>
              </div>
            </div>
            <div class="screen_box">
              <div v-for="(item, index) in hotModels" :key="index" @click="toBuyCar('vehicleType', item.value)">
                <span>{{ item.text }}</span>
              </div>
            </div>
          </div>
          <div class="right-box">
            <div class="title">
              <span>我要卖车</span>
              <div class="total">已有 <i>{{daysFromToday}}</i> 人提交申请</div>
            </div>
            <div class="sell-box">
              <div class="sell-car-input">
                <el-input class="el-input-sell" placeholder="请输入手机号" v-model="usertel" clearable> </el-input>
              </div>
              <div class="btn">
                <div @click="toSellCar">预约卖车</div>
                <div>我要咨询</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 内容区 -->
    <div class="content">
      <div class="w">
        <!-- 检测认证车 -->
        <div class="title">
          <h3>精品推荐</h3>
          <span @click="toBuyCar">更多>></span>
        </div>

        <div class="banner-box">
          <div style="width:75%;display:flex;flex-wrap:wrap;">
            <div class="box1" @click="toBuyCar('certifyTag', '2')">
              <img src="../assets/img/u140.jpg" alt="" />
            </div>
            <div class="box2" @click="toBuyCar('certifyTag', '1')">
              <img src="../assets/img/u142.jpg" alt="" />
            </div>
            <div class="box4" @click="toBuyCar('certifyTag', '3')">
              <img src="../assets/img/u144.jpg" alt="" />
            </div>
            <div class="box5" @click="toBuyCar('price', '2')">
              <img src="../assets/img/u146.jpg" alt="" />
            </div>
            <div class="box6" @click="toBuyCar('price', '1')">
              <img src="../assets/img/u148.jpg" alt="" />
            </div>
          </div>
          <div style="width:25%;" @click="toBuyCar('vehicleType', '8')">
            <div class="box3">
              <img src="../assets/img/u150.jpg" alt="" />
            </div>
          </div>
        </div>
        <!-- 专业认证 -->
        <div class="title">
          <h3>专业认证</h3>
          <span @click="toBuyCar">更多>></span>
        </div>

        <div class="car_list">
          <el-row :gutter="25">
            <el-col :span="6" v-for="item in listCertifyCar" :key="item.tradeId">
              <div class="car_box" @click="toCarDetail(item.tradeId)">
                <!-- <img :src="imgUrl" class="imgUrl" v-if="item.certifyTag == 1" /> -->
                <div class="car_img">
                  <img v-if="item.coverUrl" :src="item.coverUrl" />
                  <img v-else src="../assets/img/default-car.png" fit="contain" />
                </div>
                <div class="car_name">{{ item.vehicleName }}</div>
                <div class="car_price">
                  <span v-if="item.showPrice">￥{{ item.showPrice }}万</span>
                </div>
                <div class="car_text">
                  <span v-if="item.registMonth">{{ item.registMonth || '未' }}上牌</span>
                  <span v-if="item.mileageCount">{{ item.mileageCount }}万公里</span>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="banner" v-if="listGreatDealCarFilmstrip">
          <img :src="listGreatDealCarFilmstrip.pic" alt="" />
        </div>
      </div>
    </div>

    <!-- 流程区 -->
    <div class="flow-box">
      <div class="w">
        <div class="box1">
          <span :class="{ active: flowActive == 1 }" @click="flowActive = 1">买车流程</span> <span>|</span> <span :class="{ active: flowActive == 2 }" @click="flowActive = 2">卖车流程</span>
        </div>
        <div class="box2">{{ flowActive == 1 ? '预约看车' : '预约咨询' }}</div>
        <div class="box3" v-if="flowActive == 1">
          <div>
            <img src="../assets/img/u297.svg" alt="" />
            <span>预约看车</span>
            <i>>></i>
          </div>
          <div>
            <img src="../assets/img/u302.svg" alt="" />
            <span>专人带看</span>
            <i>>></i>
          </div>
          <div>
            <img src="../assets/img/u311.svg" alt="" />
            <span>签署合同</span>
            <i>>></i>
          </div>
          <div>
            <img src="../assets/img/u320.svg" alt="" />
            <span>交易过户</span>
          </div>
        </div>
        <div class="box3" v-if="flowActive == 2">
          <div>
            <img src="../assets/img/u297.svg" alt="" />
            <span>预约咨询</span>
            <i>>></i>
          </div>
          <div>
            <img src="../assets/img/u338.svg" alt="" />
            <span>检测评估</span>
            <i>>></i>
          </div>
          <div>
            <img src="../assets/img/u311.svg" alt="" />
            <span>签署合同</span>
            <i>>></i>
          </div>
          <div>
            <img src="../assets/img/u320.svg" alt="" />
            <span>交易过户</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 资讯区 -->
    <div class="message">
      <div class="w">
        <div class="title">
          <h3>新闻资讯</h3>
          <span @click="toNewList">更多>></span>
        </div>
        <div class="info" v-if="listNews[0]">
          <div
            v-for="(item, index) in listNews[0].newsList.slice(0,3)"
            :key="index"
            class="box1 box"
            @click="toNewsDetail(item.nId)">
            <img :src="item.nPic" alt="" />
            <div class="text">
              <h4>{{ item.catName }}</h4>
              <div>{{ item.nTitle }}</div>
            </div>
          </div>
          <!-- <div class="box1 box" @click="toNewsDetail(listNews[0].newsList[1].nId)">
            <img :src="listNews[0].newsList[1].nUrl" alt="" />
            <div class="text">
              <h4>{{ listNews[0].newsList[1].catName }}</h4>
              <div>{{ listNews[0].newsList[1].nTitle }}</div>
            </div>
          </div> -->
          <!-- <div class="box2 box">
            <div v-for="(item, index) in listNews[1].newsList" :key="index" @click="toNewsDetail(item.nId)">{{ item.nTitle }}</div>
          </div> -->
        </div>
      </div>
    </div>

    <!-- 友情链接 -->
    <div class="link-box" v-if="websiteLink.length > 0">
      <div class="w">
        <div class="title">
          <h3>友情链接</h3>
        </div>
        <div class="link">
          <span v-for="(item, index) in websiteLink" :key="index" @click="toWebLink(item.webUrl)">{{ item.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import menus from '../utils/menu'
export default {
  data() {
    return {
      keyword: '',
      swipeHeight: '',
      marketInfo: '',
      banners: [],
      hotBrands: [],
      hotModels: [],
      carPrices: [],
      listCertifyCar: [],
      listCertifyCarFilmstrip: '',
      listGreatDealCar: [],
      listGreatDealCarFilmstrip: '',
      listLatestCar: [],
      listLatestCarFilmstrip: '',
      listNews: [],
      carcount: '',
      // 城市
      city: '',
      // 流程
      flowActive: 1,
      // 卖车电话
      usertel: '',
      websiteLink: [],
      imgUrl: '',
      date: '2022-10-01'
    }
  },
  created() {
    var menuActive = this.$route.name
    if (menuActive == this.$store.state.menuActive) {
    } else {
      var keys = Object.keys(menus)
      if (keys.findIndex(item => item == menuActive) != -1) {
        this.$store.commit('setMenuActive', menuActive)
      }
    }
    this.swipeHeight = window.screen.availWidth * 0.33

    // 认证车源
    this.getListCertifyCar()

    this.getBanners()
    this.getHotBrands()
    this.getCommonBox()

    // 新闻
    this.getListNews()
    // 总数
    this.getCarcount()

    // 友情链接
    this.getWebsiteLink()
    // 放心车图标
    this.comm()
  },
  methods: {
    async comm() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/config/index', {
        params: {
          keys: 'index_fxc_imgurl'
        }
      })
      if (data.success) {
        this.imgUrl = data.data.list[0].v
      }
    },
    async getBanners() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/index/banners', {
        params: {
          type: 1
        }
      })
      if (data.success) {
        this.banners = data.data.list
      }
    },
    async getHotBrands() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/config/hotBrands')
      if (data.success) {
        this.hotBrands = data.data.list.splice(0, 7)
      }
    },
    async getCommonBox() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/config/commonBox', {
        params: {
          selectCode: 'carPrice,hotModel'
        }
      })
      if (data.success) {
        this.carPrices = data.data.carPrice

        this.hotModels = data.data.hotModel
      }
    },
    async getListCertifyCar() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/index/listCertifyCar?city=' + this.city)
      if (data.success) {
        data.data.page.rows.forEach(item => {
          if (!item.registMonth) {
            item.registMonth = '未'
          }
          if (!item.regionName) {
            item.regionName = ''
          }
        })
        this.listCertifyCar = data.data.page.rows
        this.listCertifyCarFilmstrip = data.data.filmstrip
      }
    },
    async getListGreatDealCar() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/index/listGreatDealCar?city=' + this.city)
      if (data.success) {
        data.data.page.rows.forEach(item => {
          if (!item.registMonth) {
            item.registMonth = '未'
          }
          if (!item.regionName) {
            item.regionName = ''
          }
        })
        this.listGreatDealCar = data.data.page.rows
        this.listGreatDealCarFilmstrip = data.data.filmstrip
      }
    },
    async getListLatestCar() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/index/listLatestCar?city=' + this.city)
      if (data.success) {
        data.data.page.rows.forEach(item => {
          if (!item.registMonth) {
            item.registMonth = '未'
          }
          if (!item.regionName) {
            item.regionName = ''
          }
        })
        this.listLatestCar = data.data.page.rows
        this.listLatestCarFilmstrip = data.data.filmstrip
      }
    },

    async getListNews() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/index/listNews', {
        params: {
          pageNo: 1,
          pageSize: 5,
          orders: 1,
          catid: '',
          keyword: '',
          isrecom: 0
        }
      })
      if (data.success) {
        this.listNews = data.data.list
      }
    },
    async getCarcount() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/index/carcount')
      if (data.success) {
        this.carcount = data.data
      }
    },
    async getWebsiteLink() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/config/websiteLink')
      if (data.success) {
        this.websiteLink = data.data.list
      }
    },
    flowActiveL(type) {
      this.flowActive = type
    },
    toBuyCar(name, value) {
      if (name == 'keyword') {
        this.$router.push({
          path: '/buy-car',
          query: {
            keyword: this.keyword
          }
        })
      } else {
        this.$router.push({
          path: '/buy-car',
          query: {
            [name]: value
          }
        })
      }
    },
    toSellCar() {
      this.$router.push({
        path: '/sell-car',
        query: {
          usertel: this.usertel
        }
      })
    },
    toCarDetail(tradeId) {
      this.$router.push({
        path: '/car-detail',
        query: {
          tradeId: tradeId
        }
      })
    },
    // 新闻详情
    toNewsDetail(id) {
      this.$router.push({
        path: '/news-detail',
        query: {
          newsId: id
        }
      })
    },
    // 新闻列表
    toNewList(id) {
      this.$router.push({
        path: '/news'
      })
    },
    // 城市切换
    cityChange(val) {
      this.city = val
      this.getListCertifyCar()
      this.getListGreatDealCar()
    },
    // 跳转图片链接
    toWebLink(url) {
      window.open(url)
    }
  },
  computed: {
    // 计算属性：计算日期距离今天的天数
    daysFromToday() {
      const today = new Date()
      const someDate = new Date(this.date)
      const timeDiff = Math.abs(today.getTime() - someDate.getTime())
      const daysDiff = timeDiff / (1000 * 3600 * 24)// 转换为天数
      return Math.floor(daysDiff)
    }
  }
}
</script>

<style lang="less">
.el-input-index {
  .el-input__icon {
    line-height: 35px;
  }
  input.el-input__inner {
    border-radius: 4px;
    background-color: rgba(255, 255, 255, 0.1);
    color: #000;
  }
}
.sell-car-input {
  height: 50px;
  input.el-input__inner {
    border-radius: 4px;
    background-color: rgba(255, 255, 255, 0.1);
    color: #000;
  }
}
</style>
<style lang="less" scoped>
.el-col {
  margin-bottom: 20px;
}
img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.swipe {
  width: 100%;
  background-color: #666;
  position: relative;
  .swipe_box {
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.container {
  background-color: rgba(245, 245, 247, 1);
}
.screen {
  height: 180px;
  position: relative;
  .w {
    position: absolute;
    top: -100px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 999;
    background-color: #fff;
    box-shadow: 0 0 10px #bbb;
  }
  .screen_box {
    display: flex;
    justify-content: space-between;
    .title {
      padding: 0 10px;
      display: flex;
      line-height: 50px;
      width: 100%;
      justify-content: space-between;
      font-size: 14px;
      span {
        font-size: 24px;
        color: #000;
      }
      .search {
        width: 260px;
        height: 35px;
      }
      .total {
        i {
          font-style: normal;
          font-size: 24px;
          color: #fd6f1b;
        }
      }
    }
    .left-box {
      width: 60%;
      padding: 10px;
      .screen_box {
        div {
          display: flex;
          width: 15%;
          height: 60px;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          img {
            width: 25px;
            height: 25px;
          }
        }
      }
    }
    .right-box {
      width: 40%;
      padding: 10px;
      .sell-box {
        height: 180px;
        display: flex;
        padding: 20px;
        flex-direction: column;
        justify-content: space-between;
        .btn {
          display: flex;
          justify-content: space-between;
          div {
            width: 42%;
            height: 60px;
            line-height: 60px;
            text-align: center;
            background-color: rgba(253, 111, 27, 1);
            color: #fff;
          }
          & div:nth-of-type(2) {
            background-color: rgba(23, 220, 79, 1);
          }
        }
      }
    }
  }
}

.content {
  // padding: 20px 0;
  .w {
    .title {
      display: flex;
      justify-content: space-between;
      padding: 10px 0;
      border-bottom: 1px solid #ccc;
      cursor: pointer;
      color: #888;
      font-size: 14px;
      h3 {
        font-weight: normal;
        font-size: 18px;
        color: #000;
      }
    }
    .banner-box {
      margin: 20px 0;
      display: flex;
      flex-wrap: wrap;
      .box1 {
        width: 66%;
        height: 170px;
      }
      .box2 {
        width: 34%;
        height: 170px;
      }
      .box3 {
        width: 100%;
        height: 340px;
      }
      .box4 {
        width: 33%;
        height: 170px;
      }
      .box5 {
        width: 33%;
        height: 170px;
      }
      .box6 {
        width: 34%;
        height: 170px;
      }
    }
    .car_list {
      padding: 20px 0;
      .car_box {
        height: 295px;
        padding-bottom: 5px;
        background-color: #fff;
        cursor: pointer;
        position: relative;
        .imgUrl {
          position: absolute;
          width: 3.5rem;
          height: 3.5rem;
          left: 1rem;
        }
        .car_img {
          width: 100%;
          height: 180px;
        }
        .car_name {
          white-space: nowrap; /*超出的空白区域不换行*/
          overflow: hidden; /*超出隐藏*/
          text-overflow: ellipsis; /*文本超出显示省略号*/
          line-height: 2;
          padding: 0 15px;
          margin-top: 15px;
        }
        .car_text {
          display: flex;
          line-height: 2;
          font-size: 14px;
          color: #999;
          padding: 0 15px;
          span {
            margin-right: 15px;
          }
        }
        .car_price {
          padding: 0 15px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #f37420;
          font-size: 20px;
        }
      }
      .car_box:hover {
        box-shadow: 0 0 10px #bbb;
      }
    }
  }
}

.flow-box {
  background: url(../assets/img/u262.jpg) no-repeat;
  margin: 0 auto;
  width: 100%;
  height: 378px;
  background-size: 100% 100%;
  .active {
    border-bottom: 2px solid #fd6f1b;
  }
  .box1 {
    font-size: 20px;
    padding: 50px 0;
    span {
      line-height: 2;
      margin-right: 10px;
      cursor: pointer;
    }
  }
  .box2 {
    margin: 0 0 60px;
    font-size: 28px;
  }
  .box3 {
    display: flex;
    div {
      height: 60px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      position: relative;
      margin-right: 50px;
      img {
        height: 26px;
        width: 26px;
      }

      i {
        position: absolute;
        bottom: 4px;
        right: -35px;
        font-style: normal;
      }
    }
  }
}

.message {
  .w {
    .title {
      display: flex;
      justify-content: space-between;
      padding: 10px 0;
      border-bottom: 1px solid #ccc;
      cursor: pointer;
      color: #888;
      font-size: 14px;
      h3 {
        font-weight: normal;
        font-size: 18px;
        color: #000;
      }
    }
    .info {
      height: 200px;
      display: flex;
      justify-content: space-between;
      padding: 30px 0;
    }
    .box {
      width: 30%;
      height: 100%;
      border: 1px solid #ccc;
      display: flex;
      cursor: pointer;
    }
    .box1 {
      img {
        width: 45%;
      }
      .text {
        width: 55%;
        h4 {
          text-indent: 2em;
          line-height: 1.5;
          height: 30%;
        }
        div {
          height: 70%;
          text-indent: 2em;
          line-height: 1.5;
          color: #888;
        }
      }
    }
    .box2 {
      display: flex;
      padding: 10px;
      line-height: 1.5;
      flex-direction: column;
      div {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      div:hover {
        color: #fd6f1b;
      }
    }
  }
}

.link-box {
  padding: 20px;
  .w {
    .title {
      display: flex;
      justify-content: space-between;
      padding: 10px 0;
      border-bottom: 1px solid #ccc;
      cursor: pointer;
      color: #888;
      font-size: 14px;
      h3 {
        font-weight: normal;
        font-size: 18px;
        color: #000;
      }
    }
    .link {
      width: 100%;
      margin: 20px 0 0;
      display: flex;
      flex-wrap: wrap;
      padding: 10px 10px 0;
      background-color: #fff;
      span {
        margin-right: 20px;
        margin-bottom: 10px;
        font-size: 14px;
        color: #888;
      }
      span:hover {
        color: #fd6f1b;
        cursor: pointer;
      }
    }
  }
}
</style>
